import { Component, Input } from '@angular/core';

import { AuthenticationService } from '@app/auth';

import { ParticipantService } from '@shared/services/participant/participant.service';
import { PlRouter } from '@shared/services/pl-router.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';

@Component({
  selector: 'pl-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  @Input() public isMenuOpen: boolean = false;
  @Input() public hideMenu: boolean = false;
  @Input() public hideProfileSection: boolean = false;
  @Input() public disableLinkOnPlLogo: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private participantService: ParticipantService,
    private plRouter: PlRouter,
  ) {}

  public logout(): void {
    this.authenticationService.logout();
  }

  public onMenuButtonCLick(): void {
    this.participantService.toggleLeftMenu();
  }

  public onPlLogoClick(event: MouseEvent): void {
    if (!this.disableLinkOnPlLogo) {
      this.plRouter.navigate([getRoutePath(PlRoute.home)], { replaceUrl: false }, event);
    }
  }
}
